/**
 * Quando o nome do contato é o próprio número (caso comum em WhatsApp sem
 * agenda salva), retorna ele formatado como telefone curto (últimos 4 dígitos
 * mascarados). Evita expor número completo em listas/cards de UI pública.
 */
const PHONE_RE = /^[+\d\s().-]{6,}$/;

export const maskTitleIfPhone = (title) => {
  if (!title || typeof title !== "string") return title;
  const trimmed = title.trim();
  if (!PHONE_RE.test(trimmed)) return trimmed;
  const digits = trimmed.replace(/\D/g, "");
  if (digits.length < 8) return trimmed;
  const last4 = digits.slice(-4);
  return `+${digits.slice(0, digits.length - 4).slice(0, 6)}…${last4}`;
};

export default { maskTitleIfPhone };
